"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_router_1 = require("vue-router");
const Layout_vue_1 = tslib_1.__importDefault(require("@/layout/Layout.vue"));
const routes = [
    {
        path: '/',
        name: 'Layout',
        component: Layout_vue_1.default,
    },
];
const router = (0, vue_router_1.createRouter)({
    history: (0, vue_router_1.createWebHistory)(process.env.BASE_URL),
    routes,
});
exports.default = router;
